import { Box } from "@mui/material";
import { pageContainer, desktopPageContainer } from "./containerStyles";

const PageContainer = ({ children, isMobile = true }) => {
  return (
    <Box
      className="page-container"
      sx={isMobile ? pageContainer() : desktopPageContainer()}
    >
      {children}
    </Box>
  );
};

export default PageContainer;
